import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XMarkIcon } from '@heroicons/react/24/outline';

const imgTeoria      = require('../../../static/images/oferta-educativa/teoria-musical.webp');
const imgCursos      = require('../../../static/images/oferta-educativa/cursos-de-musica.webp');
const imgDiplomados  = require('../../../static/images/oferta-educativa/diplomados.webp');
const imgBaile       = require('../../../static/images/oferta-educativa/baile.webp');
const imgEnsambles   = require('../../../static/images/oferta-educativa/ensambles.webp');
const imgConciertos  = require('../../../static/images/oferta-educativa/conciertos.webp');
const imgSalones     = require('../../../static/images/oferta-educativa/salones-de-estudio.webp');
const imgKids        = require('../../../static/images/oferta-educativa/larghetto-kids.webp');
const imgMasterclass = require('../../../static/images/oferta-educativa/master-class.webp');

const OFERTA = [
  { id: 'teoria',     nombre: 'Teoría Musical',    img: imgTeoria,      color: '#FFB300', descripcion: 'Fundamentos de armonía, solfeo, lectura musical y entrenamiento auditivo. La base que todo músico necesita para crecer.',                                                               whatsappMsg: 'Hola, me interesa el curso de Teoría Musical en Larghetto.' },
  { id: 'cursos',     nombre: 'Cursos de Música',  img: imgCursos,      color: '#2962FF', descripcion: 'Clases individuales o grupales de guitarra, piano, batería, violín, canto y más. Aprende a tu ritmo con maestros certificados.',                                                      whatsappMsg: 'Hola, me interesa conocer los cursos de música en Larghetto.' },
  { id: 'diplomados', nombre: 'Diplomados',         img: imgDiplomados,  color: '#D32F2F', descripcion: 'Programas intensivos con certificación oficial RSL, ABRSM y UWL. Formación profesional para quienes buscan llevar su música al siguiente nivel.',                                                      whatsappMsg: 'Hola, me interesa obtener información sobre los Diplomados en Larghetto.' },
  { id: 'baile',      nombre: 'Baile',              img: imgBaile,       color: '#F06292', descripcion: 'Salsa, cumbia, contemporáneo y urbano. Coordinación, expresión y diversión para todas las edades en un espacio seguro y profesional.',                                               whatsappMsg: 'Hola, me interesan las clases de Baile en Larghetto.' },
  { id: 'ensambles',  nombre: 'Ensambles',          img: imgEnsambles,   color: '#7E57C2', descripcion: 'Toca en conjunto con otros músicos. Desarrolla tu sentido del ritmo, la escucha y el trabajo en equipo sobre el escenario.',                                                        whatsappMsg: 'Hola, me interesa participar en los Ensambles de Larghetto.' },
  { id: 'conciertos', nombre: 'Conciertos',         img: imgConciertos,  color: '#FFA000', descripcion: 'Presenta lo que aprendes en escenarios reales. Nuestros conciertos son el espacio donde los alumnos brillan frente al público.',                                                    whatsappMsg: 'Hola, quiero información sobre los Conciertos y presentaciones en Larghetto.' },
  { id: 'salones',    nombre: 'Salones de Estudio', img: imgSalones,     color: '#E91E63', descripcion: 'Instalaciones acústicamente tratadas, equipadas con los mejores instrumentos y tecnología para que tu práctica sea efectiva.',                                                      whatsappMsg: 'Hola, me interesa conocer los Salones de Estudio de Larghetto.' },
  { id: 'kids',       nombre: 'Larghetto Kids',     img: imgKids,        color: '#03A9F4', descripcion: 'Programa diseñado para niños de 4 a 7 años. Aprenden música jugando: ritmo, solfeo, canto e instrumentos en un ambiente creativo.',                                                 whatsappMsg: 'Hola, me interesa el programa Larghetto Kids para mi hijo/a.' },
  { id: 'masterclass',nombre: 'Master Class',       img: imgMasterclass, color: '#4CAF50', descripcion: 'Sesiones intensivas con músicos y artistas de trayectoria profesional. Experiencias únicas que transforman tu visión de la música.',                                                whatsappMsg: 'Hola, me interesa información sobre las Master Class en Larghetto.' },
];

export default function OfertaEducativa() {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') setSelected(null); };
    if (selected) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [selected]);

  return (
    <>
      <section id="oferta" className="bg-white py-24 md:py-32">

        <div className="text-center px-4 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-gray-500 uppercase tracking-[0.3em] text-sm mb-4">Lo que ofrecemos</p>
            <h2 className="text-5xl md:text-6xl font-black text-black">Oferta Educativa</h2>
          </motion.div>
        </div>

        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {OFERTA.map((item) => (
              <button
                key={item.id}
                onClick={() => setSelected(item)}
                className="flex flex-col rounded-2xl border border-gray-200 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 overflow-hidden cursor-pointer bg-white"
              >
                <div className="w-full p-4" style={{ aspectRatio: '1/1' }}>
                  <img src={item.img} alt={item.nombre} className="w-full h-full object-contain" loading="eager" decoding="async" draggable={false} />
                </div>
                <div className="px-3 pb-4 text-center">
                  <span className="text-base font-black text-gray-900 leading-tight">{item.nombre}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

      </section>

      <AnimatePresence>
        {selected && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            onClick={() => setSelected(null)}
          >
            <div className="absolute inset-0 bg-black/70" />
            <motion.div
              initial={{ opacity: 0, scale: 0.92, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.92, y: 20 }}
              transition={{ type: 'spring', damping: 25, stiffness: 300 }}
              className="relative z-10 bg-white rounded-3xl p-8 max-w-md w-full shadow-2xl"
              style={{ borderTop: `4px solid ${selected.color}` }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setSelected(null)}
                className="absolute top-4 right-4 p-1.5 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
                aria-label="Cerrar"
              >
                <XMarkIcon className="w-4 h-4 text-gray-500" />
              </button>

              <img src={selected.img} alt={selected.nombre} className="w-16 h-16 object-contain mb-6 mx-auto" draggable={false} />

              <h3 className="text-3xl font-black text-center mb-3" style={{ color: selected.color }}>
                {selected.nombre}
              </h3>

              <p className="text-gray-500 text-center text-sm leading-relaxed mb-8">
                {selected.descripcion}
              </p>

              <a
                href={`https://wa.me/5576737753?text=${encodeURIComponent(selected.whatsappMsg)}`}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-3 w-full py-4 px-6 rounded-2xl font-bold text-white text-sm tracking-wide"
                style={{ backgroundColor: '#25D366' }}
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                </svg>
                Más información por WhatsApp
              </a>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
